export default __webpack_public_path__ + "static/media/Loading Chat.261d7d98.svg";